import { useEffect } from 'react';

const useKeyPress = (callback, key, ctrlKeyRequired = false, shiftKeyRequired = false) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        event.key.toLowerCase() === key.toLowerCase() &&
        (!ctrlKeyRequired || (ctrlKeyRequired && event.ctrlKey)) &&
        (!shiftKeyRequired || (shiftKeyRequired && event.shiftKey))
      ) {
        event.preventDefault();
        callback();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [callback, key, ctrlKeyRequired, shiftKeyRequired]);
};

export default useKeyPress;
